/**
 * Created by mauget on 1/26/16.
 */

//CommandGenericFactory.js

import $ from 'jquery';
import constants from 'Constants.js';
import sequenceService from 'SequenceService';
import factoryService from 'FactoryService';
import BehaviorModel    from 'BehaviorModel';
import CommandGenericView from 'behaviors/CommandGenericView';
import BaseBehaviorFactory 		from 'BaseBehaviorFactory';
import WorkflowModel from 'WorkflowModel';
import listService      from 'ListService';

const SILENT = constants.MODEL_SILENT;
const EMPTY = constants.STRING_EMPTY;

class CommandGenericFactory extends BaseBehaviorFactory {

    createView( factoryKey, pos ) {
        const attributes = factoryService.behaviorsFactories[factoryKey];
        attributes.factoryKey = factoryKey;

        var behaviorModel = new BehaviorModel ();
        
        behaviorModel.set(attributes, SILENT );
        behaviorModel.set({
            autosummary: 'true',
            summary: EMPTY,   // All lowercase in PF
            autoSummaryArea: '',
            x: pos.left,
            y: pos.top
        }, SILENT );

        const view = new CommandGenericView( { model: behaviorModel,  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: sequenceService.nextDomId(), type: 'behavior' } );

        view.model.resetLastState();

        return view;
    }

    createWorkflowView( factoryKey, pos, id = undefined ) {

        const itemId = id ||  sequenceService.nextDomId();

        const attributes = factoryService.workflowFactories[ factoryKey ];
        attributes.factoryKey = factoryKey;
        attributes.autosummary = 'true'; // All-lowercase key in PF
        attributes.summary = EMPTY;
        attributes.description = EMPTY;
        attributes.text = 'Comment';
        attributes.x = pos.left;
        attributes.y = pos.top;
        attributes.id = itemId;
        attributes.name = 'Stage' + listService._suffix({});
        if(listService.getWorkflowStages(false, false).size === 0){
            attributes.isDefault = true;
            if(!listService.workflowProperties._root.entries[2][1] || listService.workflowProperties._root.entries[2][1] === 'null' ){
                listService.workflowProperties._root.entries[2][1] = itemId;
            }
        }

        const view = new CommandGenericView( { model: new WorkflowModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: itemId, type: factoryKey } );

        return view;
    }
}

const commandGenericFactory = new CommandGenericFactory();
export default commandGenericFactory;
